import validate from 'lib/utils/validationRules';
import creditCardType from 'lib/utils/creditCardType';

import { SPECIAL_PAYMENT_OPTIONS } from 'definitions/payment';

// Алгоритм Луна, нужен для проверки последнего символа в карте
export function luhn(cardNumber) {
  let arr = [];

  cardNumber = cardNumber.toString();
  for (let i = 0; i < cardNumber.length; i++) {
    if (i % 2 === 0) {
      let m = parseInt(cardNumber[i]) * 2;
      if (m > 9) {
        arr.push(m - 9);
      } else {
        arr.push(m);
      }
    } else {
      let n = parseInt(cardNumber[i]);
      arr.push(n);
    }
  }

  const summ = arr.reduce((a, b) => a + b);

  return Boolean(!(summ % 10));
}

export function getMaskedCardPan(value) {
  const placeholder = value.length === 16 ? 'xxxxxx' : 'xxxxxxxx';
  const startPart = value.slice(0, 6);
  const endPart = value.slice(-4);

  return `${startPart}${placeholder}${endPart}`;
}

export function formatAccountNumberByShort(value) {
  return `**** ${value.slice(-4)}`;
}

export function formatPaymentMethod(accountNumber, cardPsType) {
  return `${cardPsType} **** ${accountNumber.slice(-4)}`;
}

export function formatCardPsType(accountNumber, cardPsType, paymentMethod) {
  if (SPECIAL_PAYMENT_OPTIONS.includes(paymentMethod)) {
    return cardPsType;
  }

  if (validate.isNotString(accountNumber)) {
    return null;
  }

  const creditCardTypeList = creditCardType(accountNumber);

  if (validate.isEmptyArray(creditCardTypeList)) {
    return null;
  }

  return creditCardTypeList[0].niceType;
}

export function formatGoogleAccountNumber(accountNumber, cardPsType) {
  const IS_FIRST_NUMBER_REGEX = /^\d/;
  const hiddenСharacters = accountNumber.length === 16 ? ' **** **** ' : '**** ******';

  const formattedAccountNumber = IS_FIRST_NUMBER_REGEX.test(accountNumber)
    ? `${accountNumber.slice(0, 4)}${hiddenСharacters}${accountNumber.slice(-4)}`
    : formatPaymentMethod(accountNumber, cardPsType);

  return formattedAccountNumber;
}
